import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import HowWeBuildSection from './components/HowWeBuildSection';
import WhatWeBuildSection from './components/WhatWeBuildSection';
import WhyAInnovationSection from './components/WhyAInnovationSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FlowingBackground from '@/components/feature/FlowingBackground';

export default function Home() {
  return (
    <main className="relative">
      <FlowingBackground />
      <div className="relative z-10">
        <Navbar />
        <HeroSection />
        <AboutSection />
        <HowWeBuildSection />
        <WhatWeBuildSection />
        <WhyAInnovationSection />
        <ContactSection />
        <Footer />
      </div>
    </main>
  );
}